module.exports = __webpack_public_path__ + "img/Dantam Bridal 20.5732ea61.jpg";